// Central content + bilingual UI strings for the GRABARTE prototype.
// Español = idioma principal. Inglés = secundario.

export const IMG = {
  marketingHero:
    "https://images.unsplash.com/photo-1596040078821-9b5f50e71ea5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBldmVudCUyMG1hcmtldGluZyUyMHN0YWdlfGVufDB8fHx8MTc4Mjk3NzAyOXww&ixlib=rb-4.1.0&q=85",
  audiovisualHero:
    "https://images.unsplash.com/photo-1570834322056-ba3e2994ab85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBmaWxtJTIwY2FtZXJhJTIwc2V0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc4Mjk3NzAyOXww&ixlib=rb-4.1.0&q=85",
  eventos:
    "https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg",
  studio:
    "https://images.unsplash.com/photo-1691491918178-8a2e68b44919?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxmaWxtJTIwZWRpdGluZyUyMHN0dWRpbyUyMGRhcmt8ZW58MHx8fHwxNzgyOTc3MTE4fDA&ixlib=rb-4.1.0&q=85",
  meeting:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtYXJrZXRpbmclMjBzdHJhdGVneSUyMHRlYW0lMjBtZWV0aW5nJTIwY3JlYXRpdmV8ZW58MHx8fHwxNzgyOTc3MTE4fDA&ixlib=rb-4.1.0&q=85",
  camera:
    "https://images.unsplash.com/photo-1607276159787-9ef4db5c0d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBmaWxtJTIwcHJvZHVjdGlvbiUyMGNhbWVyYXxlbnwwfHx8fDE3ODI5NzcxMTh8MA&ixlib=rb-4.1.0&q=85",
  desert:
    "https://images.unsplash.com/photo-1600721296496-bb850e5310ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxkb2N1bWVudGFyeSUyMHRyYXZlbCUyMGZpbG1pbmclMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgyOTc3MTE4fDA&ixlib=rb-4.1.0&q=85",
  mountainFilmer:
    "https://images.unsplash.com/photo-1761872936122-4aca27d3f258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxkb2N1bWVudGFyeSUyMHRyYXZlbCUyMGZpbG1pbmclMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgyOTc3MTE4fDA&ixlib=rb-4.1.0&q=85",
  rockFilmer:
    "https://images.unsplash.com/photo-1517411020229-9cbb75afed2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxkb2N1bWVudGFyeSUyMHRyYXZlbCUyMGZpbG1pbmclMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgyOTc3MTE4fDA&ixlib=rb-4.1.0&q=85",
  evgHeader:
    "https://grabarte360.com/wp-content/uploads/2024/01/EVG_HEADER.jpeg",
  posterA:
    "https://images.unsplash.com/photo-1554875032-2de0215e64c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxtb3ZpZSUyMHBvc3RlciUyMGNpbmVtYXRpYyUyMHBvcnRyYWl0JTIwZHJhbWF0aWN8ZW58MHx8fHwxNzgzMDEyMzUzfDA&ixlib=rb-4.1.0&q=85",
  posterB:
    "https://images.unsplash.com/photo-1553027267-447bbee1bec1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxtb3ZpZSUyMHBvc3RlciUyMGNpbmVtYXRpYyUyMHBvcnRyYWl0JTIwZHJhbWF0aWN8ZW58MHx8fHwxNzgzMDEyMzUzfDA&ixlib=rb-4.1.0&q=85",
  lightLeak:
    "https://images.unsplash.com/photo-1624115773145-9b77fe912897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGNpbmVtYXRpYyUyMGxpZ2h0JTIwbGVha3xlbnwwfHx8fDE3ODMwMTIyMjJ8MA&ixlib=rb-4.1.0&q=85",
  filmSet:
    "https://images.pexels.com/photos/1117132/pexels-photo-1117132.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  analytics:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  growth:
    "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  filmmaker:
    "https://images.unsplash.com/photo-1532005051008-7bdebde54683?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  setLighting:
    "https://images.unsplash.com/photo-1563199592-687f283ab0e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  gastronomy:
    "https://images.pexels.com/photos/27381531/pexels-photo-27381531.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000",
  wine:
    "https://images.unsplash.com/photo-1585553616435-2dc0a54e271d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gala:
    "https://images.unsplash.com/photo-1509710398975-6454dcdf049f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  rMgm: "https://grabarte360.com/versionanterior/wp-content/uploads/2020/08/MGM_SLIDE_01-1.jpg",
  rAmexExp: "https://grabarte360.com/versionanterior/wp-content/uploads/2021/03/hero-caso-amex-experience-1.png",
  rAmexTrends: "https://grabarte360.com/versionanterior/wp-content/uploads/2020/08/01.jpg",
  rEntelgy: "https://grabarte360.com/versionanterior/wp-content/uploads/2020/08/ENTELGY_HEADER-1-scaled.jpg",
  rOrange: "https://grabarte360.com/versionanterior/wp-content/uploads/2020/08/ORANGE_HEADER_01.jpg",
  rTelefonica: "https://grabarte360.com/versionanterior/wp-content/uploads/2020/08/TELEFONICA_HEADER-2.png",
};

export const CLIENTS = [
  "American Express",
  "Telefónica",
  "Mercedes-Benz",
  "Fanta",
  "Orange",
  "Leroy Merlin",
  "Mediaset España",
  "Marqués de Riscal",
  "Beam Suntory",
  "Entelgy",
];

// Branch 1 — Marketing, Comunicación y Eventos (verde)
export const MARKETING_SERVICES = [
  {
    id: "consultoria",
    image: IMG.meeting,
    title: { es: "Estrategia y Consultoría", en: "Strategy & Consulting" },
    desc: {
      es: "Consultoría estratégica y planes de comunicación digital que convierten objetivos de negocio en hoja de ruta.",
      en: "Strategic consulting and digital communication plans that turn business goals into a clear roadmap.",
    },
  },
  {
    id: "eventos",
    image: IMG.eventos,
    title: { es: "Eventos y Experiencias", en: "Events & Experiences" },
    desc: {
      es: "Jornadas, activaciones, galas y experiencias de marca memorables, del concepto a la producción integral.",
      en: "Summits, activations, galas and memorable brand experiences, from concept to full production.",
    },
  },
  {
    id: "gastronomia",
    image: IMG.gastronomy,
    title: { es: "Gastronomía y Lifestyle", en: "Gastronomy & Lifestyle" },
    desc: {
      es: "Catas, maridajes y experiencias gastronómicas para marcas de vino, bebidas y lifestyle premium.",
      en: "Tastings, pairings and culinary experiences for wine, spirits and premium lifestyle brands.",
    },
  },
  {
    id: "comunicacion",
    image: IMG.analytics,
    title: { es: "Comunicación Digital", en: "Digital Communication" },
    desc: {
      es: "Contenidos, social media, SEO y narrativa de marca. Relatos que conectan y generan comunidad.",
      en: "Content, social media, SEO and brand storytelling. Narratives that connect and grow communities.",
    },
  },
  {
    id: "fidelizacion",
    image: IMG.gala,
    title: { es: "Fidelización y Recomendación", en: "Loyalty & Referral" },
    desc: {
      es: "Autores de una investigación pionera en España sobre referral marketing. Clientes convertidos en prescriptores.",
      en: "Authors of pioneering referral marketing research in Spain. Customers turned into advocates.",
    },
  },
  {
    id: "formacion",
    image: IMG.growth,
    title: { es: "Formación y RSC", en: "Training & CSR" },
    desc: {
      es: "E-learning a medida y campañas de responsabilidad social corporativa para grandes empresas e instituciones.",
      en: "Custom e-learning and corporate social responsibility campaigns for large companies and institutions.",
    },
  },
];

// Branch 2 — Producción Audiovisual y Contenidos (dorado) — Estudio de desarrollo
export const AUDIOVISUAL_CAPABILITIES = [
  {
    id: "documentales",
    image: IMG.desert,
    title: { es: "Documentales", en: "Documentaries" },
    desc: {
      es: "Producción propia y coproducción de largometrajes documentales para festivales, televisión y plataformas.",
      en: "In-house production and co-production of feature documentaries for festivals, TV and platforms.",
    },
  },
  {
    id: "peliculas",
    image: IMG.filmmaker,
    title: { es: "Películas", en: "Films" },
    desc: {
      es: "Desarrollo de ficción: guion, financiación y producción ejecutiva de largometrajes.",
      en: "Fiction development: script, financing and executive production of feature films.",
    },
  },
  {
    id: "series",
    image: IMG.studio,
    title: { es: "Series", en: "Series" },
    desc: {
      es: "Formatos serializados de ficción y no ficción para televisión y plataformas de streaming.",
      en: "Serialized fiction and non-fiction formats for television and streaming platforms.",
    },
  },
  {
    id: "programas",
    image: IMG.setLighting,
    title: { es: "Programas", en: "TV Programs" },
    desc: {
      es: "Diseño y producción de formatos y programas de televisión, del piloto a la emisión.",
      en: "Design and production of TV formats and programs, from pilot to broadcast.",
    },
  },
  {
    id: "branded",
    image: IMG.evgHeader,
    title: { es: "Branded Content", en: "Branded Content" },
    desc: {
      es: "Relatos de marca con vocación cinematográfica que integran producto y emoción de forma natural.",
      en: "Cinematic brand stories that weave product and emotion together naturally.",
    },
  },
  {
    id: "desarrollo",
    image: IMG.filmSet,
    title: { es: "Desarrollo de Proyectos", en: "Project Development" },
    desc: {
      es: "Somos un estudio de desarrollo: detectamos historias, escribimos, buscamos coproducción y las llevamos a pantalla.",
      en: "We are a development studio: we spot stories, write them, seek co-production and bring them to screen.",
    },
  },
];

// Slate audiovisual (producciones destacadas / en desarrollo)
export const SLATE = [
  {
    slug: "el-viaje-del-ganador",
    title: "El Viaje del Ganador",
    format: { es: "Largometraje documental", en: "Feature documentary" },
    status: { es: "Estrenado", en: "Released" },
    year: "2020",
    image: IMG.evgHeader,
  },
  {
    slug: "en-reconstruccion",
    title: "En Reconstrucción",
    format: { es: "Documental", en: "Documentary" },
    status: { es: "Disponible", en: "Available" },
    year: "2010",
    image: IMG.desert,
    vimeo: "16090613",
  },
];

// Proyectos / casos de éxito (ambas ramas)
export const PROJECTS = [
  {
    slug: "el-viaje-del-ganador",
    branch: "audiovisual",
    title: "El Viaje del Ganador",
    kicker: { es: "Documental", en: "Documentary" },
    summary: {
      es: "Branded content que genera turismo: un influencer lleva a sus padres octogenarios a la Riviera Maya.",
      en: "Branded content that drives tourism: an influencer takes his octogenarian parents to the Riviera Maya.",
    },
    client: "Sec. Turismo México · Min. Turismo Uruguay · American Express",
    services: {
      es: "Estrategia / Planificación / Producción audiovisual / Plan de medios",
      en: "Strategy / Planning / Audiovisual production / Media plan",
    },
    image: IMG.evgHeader,
    vimeo: null,
    youtube: "2sOHPdlk_nM",
    featured: true,
    span: "lg:col-span-8",
    body: {
      es: "Un conocido influencer de viajes uruguayo lleva a sus padres octogenarios a conocer la Riviera Maya en el viaje de sus vidas. Con este atractivo concepto realizamos una película documental para vender dos destinos turísticos. La difusión incluyó el circuito internacional de festivales de documental y su programación en televisiones de varios países.",
      en: "A well-known Uruguayan travel influencer takes his octogenarian parents to discover the Riviera Maya on the trip of their lives. With this compelling concept we produced a documentary film to promote two tourist destinations. Distribution included the international documentary festival circuit and broadcast on television in several countries.",
    },
    keys: {
      es: [
        "Aprovechar el fin de una acción de marca para generar otra aún más potente.",
        "Reenfocar el contenido para dar sentido a la participación de nuevas marcas.",
        "Mezclar la trama de viaje y los destinos con la trama humana de la familia.",
      ],
      en: [
        "Turning the end of a brand action into an even more powerful one.",
        "Refocusing the content to justify the participation of new brands.",
        "Blending the travel storyline and destinations with the family's human story.",
      ],
    },
  },
  {
    slug: "en-reconstruccion",
    branch: "audiovisual",
    title: "En Reconstrucción",
    kicker: { es: "Documental", en: "Documentary" },
    summary: {
      es: "Documental de producción propia. Una mirada íntima y humana rodada con voluntad de autor.",
      en: "In-house documentary. An intimate, human portrait shot with an auteur's eye.",
    },
    client: "Producción propia Grabarte",
    services: {
      es: "Desarrollo / Dirección / Producción",
      en: "Development / Direction / Production",
    },
    image: IMG.desert,
    vimeo: "16090613",
    featured: false,
    span: "lg:col-span-4",
    festivals: [
      "Seleccionado · Festival de Nuevo Cine Latinoamericano de La Habana",
      "Seleccionado · Festival MiradasDoc de Tenerife",
      "Seleccionado · Muestra de Cine Latinoamericano de Albacete",
      "Seleccionado · Festival de Cine Social de Granada",
    ],
    body: {
      es: "Una pieza documental de producción propia que refleja nuestra vocación como estudio de desarrollo: historias con mirada de autor llevadas de la idea a la pantalla.",
      en: "An in-house documentary piece that reflects our vocation as a development studio: author-driven stories taken from idea to screen.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "marques-de-riscal",
    branch: "audiovisual",
    title: "Marqués de Riscal",
    kicker: { es: "Branded content", en: "Branded content" },
    summary: {
      es: "Catas y maridajes en vídeo para una bodega histórica. Contenido premium con alma cinematográfica.",
      en: "Video tastings and pairings for a historic winery. Premium content with a cinematic soul.",
    },
    client: "Herederos del Marqués de Riscal",
    services: { es: "Producción audiovisual / Dirección de arte", en: "Audiovisual production / Art direction" },
    image: IMG.wine,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Serie de piezas de cata y maridaje que trasladan la sofisticación de una de las bodegas más emblemáticas de España al formato vídeo.",
      en: "A series of tasting and pairing pieces that translate the sophistication of one of Spain's most iconic wineries into video.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "desaparecidos",
    branch: "audiovisual",
    title: "Desaparecidos",
    kicker: { es: "Serie · Prime time", en: "Series · Prime time" },
    summary: {
      es: "Dirección de arte gráfico en una serie de prime time de ámbito nacional.",
      en: "Graphic art direction for a national prime-time series.",
    },
    client: "Unicorn Content · Mediaset España · Amazon Prime Video",
    services: { es: "Diseño gráfico / Dirección de arte (temporadas 2 y 3)", en: "Graphic design / Art direction (seasons 2 & 3)" },
    image: IMG.studio,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Desarrollo de la identidad y dirección de arte gráfico para una serie de ficción emitida en prime time nacional.",
      en: "Identity development and graphic art direction for a fiction series aired in national prime time.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "member-get-member",
    branch: "marketing",
    title: "Member Get Member",
    kicker: { es: "Fidelización", en: "Loyalty" },
    summary: {
      es: "Experiencias únicas como recompensa por recomendar amigos.",
      en: "Unique experiences as a reward for referring friends.",
    },
    client: "American Express",
    services: { es: "Estrategia / Marketing de recomendación", en: "Strategy / Referral marketing" },
    image: IMG.rMgm,
    vimeo: null,
    featured: false,
    span: "lg:col-span-8",
    body: {
      es: "Programa de recomendación que premia a los clientes con experiencias exclusivas por traer nuevos socios, aumentando la captación y el vínculo con la marca.",
      en: "A referral program that rewards customers with exclusive experiences for bringing new members, boosting acquisition and brand affinity.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "amex-business-trends",
    branch: "marketing",
    title: "Amex Business Trends",
    kicker: { es: "Eventos", en: "Events" },
    summary: {
      es: "Jornadas profesionales para empresarios y directivos.",
      en: "Professional summits for business owners and executives.",
    },
    client: "American Express",
    services: { es: "Eventos / Contenidos / Comunicación", en: "Events / Content / Communication" },
    image: IMG.rAmexTrends,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Ciclo de jornadas profesionales que posiciona a la marca como aliada del tejido empresarial, combinando ponencias, networking y contenidos de valor.",
      en: "A cycle of professional summits positioning the brand as an ally of the business community, combining talks, networking and valuable content.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "telefonica-elearning",
    branch: "marketing",
    title: "Telefónica",
    kicker: { es: "Formación", en: "Training" },
    summary: {
      es: "E-learning a medida para una gran empresa.",
      en: "Custom e-learning for a large enterprise.",
    },
    client: "Telefónica",
    services: { es: "Formación / E-learning", en: "Training / E-learning" },
    image: IMG.rTelefonica,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Diseño y producción de contenidos formativos digitales a medida para los equipos de una de las mayores compañías del país.",
      en: "Design and production of custom digital training content for the teams of one of the country's largest companies.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "orange-educainternet",
    branch: "marketing",
    title: "Orange · Educainternet",
    kicker: { es: "RSC", en: "CSR" },
    summary: {
      es: "Campaña y concurso juvenil para prevenir malos hábitos digitales.",
      en: "Youth campaign and contest to prevent bad digital habits.",
    },
    client: "Orange",
    services: { es: "RSC / Campaña / Contenidos", en: "CSR / Campaign / Content" },
    image: IMG.rOrange,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Iniciativa de responsabilidad social que fomenta un uso saludable de la tecnología entre los jóvenes a través de un concurso educativo de alcance nacional.",
      en: "A social responsibility initiative promoting healthy technology use among young people through a national educational contest.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "amex-experiences",
    branch: "marketing",
    title: "Amex Experiences",
    kicker: { es: "Contenidos", en: "Content" },
    summary: {
      es: "Contenidos digitales y vídeo streaming exclusivos para clientes premium.",
      en: "Exclusive digital content and video streaming for premium customers.",
    },
    client: "American Express",
    services: { es: "Contenidos / Vídeo / Streaming", en: "Content / Video / Streaming" },
    image: IMG.rAmexExp,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Programa de contenidos digitales y experiencias en vídeo streaming exclusivas para socios, reforzando el valor de pertenencia a la marca.",
      en: "A program of digital content and exclusive video streaming experiences for members, reinforcing the value of belonging to the brand.",
    },
    keys: { es: [], en: [] },
  },
  {
    slug: "entelgy",
    branch: "marketing",
    title: "Entelgy",
    kicker: { es: "Comunicación", en: "Communication" },
    summary: {
      es: "Desarrollo de narrativas y storytelling para comunicación online.",
      en: "Narrative and storytelling development for online communication.",
    },
    client: "Entelgy",
    services: { es: "Storytelling / Comunicación digital", en: "Storytelling / Digital communication" },
    image: IMG.rEntelgy,
    vimeo: null,
    featured: false,
    span: "lg:col-span-4",
    body: {
      es: "Diseño de narrativas y storytelling corporativo para trasladar de forma clara y atractiva la información online de la compañía.",
      en: "Corporate narrative and storytelling design to convey the company's online information in a clear and engaging way.",
    },
    keys: { es: [], en: [] },
  },

];

export const POSTS = [
  {
    slug: "observatorio-referral-marketing",
    date: "12/02/2024",
    title: {
      es: "Grabarte lidera el primer Observatorio de Referral Marketing de España",
      en: "Grabarte leads Spain's first Referral Marketing Observatory",
    },
    tag: "#grabarte #marketing #investigación",
    image:
      "https://grabarte360.com/wp-content/uploads/2024/02/shutterstock_1723716979-2048x1115.jpg",
  },
  {
    slug: "en-reconstruccion-festivales",
    date: { es: "Cine · Festivales", en: "Film · Festivals" },
    title: {
      es: "«En Reconstrucción» se cuela en festivales internacionales de cine",
      en: "\"En Reconstrucción\" selected at international film festivals",
    },
    tag: "La Habana · MiradasDoc · Albacete · Granada",
    image: IMG.desert,
  },
  {
    slug: "viaje-ganador-circuito",
    date: { es: "Documental", en: "Documentary" },
    title: {
      es: "«El Viaje del Ganador» recorre el circuito internacional de festivales de documental",
      en: "\"El Viaje del Ganador\" tours the international documentary festival circuit",
    },
    tag: "#grabarte #documental #brandedcontent",
    image: IMG.evgHeader,
  },
  {
    slug: "poder-marketing-recomendaciones",
    date: "28/09/2023",
    title: {
      es: "Diferenciación y fidelización: el poder del marketing de recomendaciones",
      en: "Differentiation and loyalty: the power of referral marketing",
    },
    tag: "#grabarte #fidelización #digital",
    image:
      "https://grabarte360.com/wp-content/uploads/2023/09/0374_LINKEDIN_INFORME_2023_A_V01-1.jpg",
  },
  {
    slug: "email-marketing-contenidos",
    date: "09/03/2022",
    title: {
      es: "Email marketing y contenidos: dos técnicas que impulsan el referral marketing",
      en: "Email marketing and content: two techniques that boost referral marketing",
    },
    tag: "#grabarte #contenidos #estrategia",
    image:
      "https://grabarte360.com/wp-content/uploads/2022/03/shutterstock_2172915717-2048x1365.jpg",
  },
  {
    slug: "kit-digital-fondos-europeos",
    date: { es: "Compañía", en: "Company" },
    title: {
      es: "Grabarte, beneficiaria del programa Kit Digital y los Fondos Europeos Next Generation",
      en: "Grabarte, beneficiary of the Kit Digital program and Next Generation EU Funds",
    },
    tag: "#grabarte #transformacióndigital #UE",
    image: IMG.growth,
  },
];

export const CONTACT = {
  phone: "+34 915 32 77 01",
  email: "info@grabarte360.com",
  address: "Avenida Miguel Delibes, 32",
  city: "28052 Madrid, España",
};

export const BRAIN_LAB = {
  title: { es: "Brain Lab", en: "Brain Lab" },
  desc: {
    es: "Los procesos creativos son la base de la diferenciación. En nuestro Brain Lab reunimos perfiles y perspectivas distintas para cada cliente y proyecto: de ahí nacen las ideas que marcan la diferencia.",
    en: "Creativity is where differentiation begins. In our Brain Lab we bring together different minds and perspectives for every client and project — and that's where the ideas that set brands apart are born.",
  },
};

// UI chrome strings
export const UI = {
  nav: {
    marketing: { es: "Marketing & Eventos", en: "Marketing & Events" },
    audiovisual: { es: "Producción Audiovisual", en: "Audiovisual Studio" },
    proyectos: { es: "Proyectos", en: "Work" },
    actualidad: { es: "Actualidad", en: "News" },
    contacto: { es: "Contacto", en: "Contact" },
  },
  cta: {
    talk: { es: "Hablemos", en: "Let's talk" },
    seeMore: { es: "Ver más", en: "See more" },
    viewProject: { es: "Ver proyecto", en: "View project" },
    allProjects: { es: "Todos los proyectos", en: "All projects" },
    discover: { es: "Descubrir", en: "Discover" },
    enter: { es: "Entrar", en: "Enter" },
  },
};


export const METRICS = [
  { value: "20", suffix: "", label: { es: "Años de trayectoria", en: "Years of experience" } },
  { value: "40", suffix: "+", label: { es: "Marcas y clientes", en: "Brands & clients" } },
  { value: "1", suffix: "º", label: { es: "Observatorio Referral de España", en: "Referral Observatory in Spain" } },
  { value: "360", suffix: "°", label: { es: "Estrategia integral", en: "End-to-end strategy" } },
];

export const GATEWAY = {
  audiovisual: {
    label: { es: "Cine & Documental", en: "Film & Documentary" },
    line: { es: "Creamos historias en imágenes", en: "We tell stories through images" },
    sub: { es: "Documentales, películas, series y programas de producción propia.", en: "Documentaries, films, series and programs — produced in-house." },
  },
  marketing: {
    label: { es: "Marketing & Resultados", en: "Marketing & Results" },
    line: { es: "Datos que generan negocio", en: "Data that builds business" },
    sub: { es: "Estrategia, comunicación, eventos y fidelización medibles.", en: "Measurable strategy, communication, events and loyalty." },
  },
};
